import { render, staticRenderFns } from "./terms-preview.vue?vue&type=template&id=205c4e0a"
import script from "./terms-preview.vue?vue&type=script&lang=js"
export * from "./terms-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports